import { apiClient } from './client';
import {
  BudgetRequestListItemDto,
  BudgetRequestDetailDto,
  CreateBudgetRequestRequest,
} from '../types';

export const budgetsApi = {
  list(brgId?: string): Promise<BudgetRequestListItemDto[]> {
    const query = brgId ? `?brgId=${brgId}` : '';
    return apiClient.get<BudgetRequestListItemDto[]>(`/api/budget-requests${query}`);
  },

  getById(id: string): Promise<BudgetRequestDetailDto> {
    return apiClient.get<BudgetRequestDetailDto>(`/api/budget-requests/${id}`);
  },

  getByMmRecognitionId(mmRecognitionId: number): Promise<BudgetRequestDetailDto | null> {
    return apiClient.get<BudgetRequestDetailDto>(`/api/budget-requests/recognition/${mmRecognitionId}`).catch(() => null);
  },

  create(data: CreateBudgetRequestRequest): Promise<BudgetRequestDetailDto> {
    return apiClient.post<BudgetRequestDetailDto>('/api/budget-requests', data);
  },

  approve(id: number): Promise<BudgetRequestListItemDto> {
    return apiClient.put<BudgetRequestListItemDto>(`/api/budget-requests/${id}/approve`, {});
  },

  deny(id: number, denyReason: string): Promise<BudgetRequestListItemDto> {
    return apiClient.put<BudgetRequestListItemDto>(`/api/budget-requests/${id}/deny`, { denyReason });
  },

  edit(id: number, data: CreateBudgetRequestRequest): Promise<BudgetRequestListItemDto> {
    return apiClient.put<BudgetRequestListItemDto>(`/api/budget-requests/${id}`, data);
  },

  delete(id: number): Promise<void> {
    return apiClient.delete(`/api/budget-requests/${id}`);
  },
};
